<template>
  <div class="v2-retailer-dashboard">
    <v2-dashboard-welcome-card :current-association="currentAssociation" />
    <v2-dashboard-brands-list />
    <v2-dashboard-wishlist />
    <v2-dashboard-orders-list />
  </div>
</template>

<script>
import { computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import V2DashboardWelcomeCard from '@/components/v2/dashboard/V2DashboardWelcomeCard.vue'
import V2DashboardBrandsList from '@/components/v2/dashboard/V2DashboardBrandsList.vue'
import V2DashboardWishlist from '@/components/v2/dashboard/V2DashboardWishlist.vue'
import V2DashboardOrdersList from '@/components/v2/dashboard/V2DashboardOrdersList.vue'

// Temporarily hidden per product decision:
//   - V2DashboardReferralBanner ('Invite a brand' banner)
//   - V2OnboardingChecklist
// The component files remain on disk; re-add imports + template tags to
// restore. See git history (commit prior to this one) for the 2-column
// layout with the referral banner + checklist sidebar.

export default {
  name: 'V2RetailerDashboard',
  components: {
    V2DashboardWelcomeCard,
    V2DashboardBrandsList,
    V2DashboardWishlist,
    V2DashboardOrdersList,
  },
  setup() {
    const currentAssociation = computed(() => store.getters.getCurrentAssociation)

    onMounted(() => {
      analytics.track(constants.TRACKS.PAGES.RETAILER_OPENS_DASHBOARD)
    })

    return { currentAssociation }
  },
}
</script>

<style lang="scss" scoped>
// Outer container — LayoutV2 already applies var(--v2-space-6) padding
// around the router-view, so we deliberately do not pad again here.
.v2-retailer-dashboard {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
